import { BooleanInput, Create, SimpleForm, TextInput } from 'react-admin';

const jsonFormat = (value: unknown) => (value && typeof value === 'object' ? JSON.stringify(value, null, 2) : (value as string) ?? '');
const jsonParse = (value: string) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const CountryConfigsCreate = () => (
  <Create redirect="list">
    <SimpleForm>
      <TextInput source="country" label="Country code (e.g. BR, US)" required inputProps={{ maxLength: 10 }} />
      <TextInput source="cssUrl" label="CSS URL" fullWidth />
      <TextInput source="payrollUrl" label="Payroll URL" fullWidth />
      <TextInput source="payrollUrlAuthStrategy" label="Payroll URL Auth Strategy" />
      <BooleanInput source="monthlyAccrualEnabled" label="Monthly accrual enabled" helperText="Persists under extra_options.settings.monthlyAccrualEnabled" />
      <TextInput source="extraOptions" label="Extra Options (JSON)" multiline fullWidth minRows={8} format={jsonFormat} parse={jsonParse} />
    </SimpleForm>
  </Create>
);

export default CountryConfigsCreate;
